module.exports = __webpack_public_path__ + "img/第2章_2-1_公會堂.jpg";